export default {
  繁體中文: '繁體中文',
  英语: 'English',
  '英语为谷歌翻译，可能存在翻译不准确的情况，如有问题请咨询管理员调整翻译':
    '英語為谷歌翻譯，可能存在翻譯不準確的情況，如有問題請諮詢管理員調整翻譯',
  歡迎使用: '歡迎使用',
  切換淺色: '切換淺色',
  切換深色: '切換深色',
  登出: '登出',
  後台入口: '後台入口',
  用戶管理: '用戶管理',
  後台管理: '後台管理',
  權限管理: '權限管理',
  用戶權限: '用戶權限',
  權限點: '權限點',
  日誌管理: '日誌管理',
  登入日誌: '登入日誌',
  介面訪問日誌: '介面訪問日誌',
  後台訪問日誌: '後台訪問日誌',
  鑑權日誌: '鑑權日誌',
  操作日誌: '操作日誌',
  觸達管理: '觸達管理',
  系統訊息: '系統訊息',
  個後台: '個後台',
  已篩選: '已篩選',
  搜尋後台: '搜尋後台',
  名稱: '名稱',
  簡介: '簡介',
  操作: '操作',
  拖動排序: '拖動排序',
  進入系統: '進入系統',
  暫無後台: '暫無後台',
  列表視圖: '列表視圖',
  卡片視圖: '卡片視圖',
  視圖切換: '視圖切換',
  打開方式: '打開方式',
  當前標籤頁打開: '當前標籤頁打開',
  新建標籤頁打開: '新建標籤頁打開',
  取消: '取消',
  請選擇您的主體: '請選擇您的主體',
  '此舉為區分不同主體用戶來源，請選擇您的主體，否則無法正常登錄':
    '此舉為區分不同主體用戶來源，請選擇您的主體，否則無法正常登錄',
  廣州弘策網絡科技有限公司: '廣州弘策網絡科技有限公司',
  'HEAVEN POWER INTERNATIONAL LIMITED': 'HEAVEN POWER INTERNATIONAL LIMITED',
  广东很久文化传播有限公司: '广东很久文化传播有限公司',
  確定: '確定',
  提示: '提示',
  搜索: '搜索',
  重置: '重置',
  查詢: '查詢',
  新增: '新增',
  編輯: '編輯',
  刪除: '刪除',
  保存: '保存',
  關閉: '關閉',
  暫無數據: '暫無數據',
  全部: '全部',
  狀態: '狀態',
  創建時間: '創建時間',
  更新時間: '更新時間',
  正式環境: '正式環境',
  測試環境: '測試環境',
  本地環境: '本地環境',
  其他應用: '其他應用',
  開發環境: '開發環境',
  未知系統: '未知系統',
  驗證安全手機: '驗證安全手機',
  '您的帳號開啟了手機驗證，請在獲取驗證碼之後，輸入您手機上接收到的驗證碼（請查看簡訊驗證碼或釘釘應用的驗證碼資訊）。':
    '您的帳號開啟了手機驗證，請在獲取驗證碼之後，輸入您手機上接收到的驗證碼（請查看簡訊驗證碼或釘釘應用的驗證碼資訊）。',
  手機號碼: '手機號碼',
  驗證碼: '驗證碼',
  輸入手機收到的驗證碼: '輸入手機收到的驗證碼',
  獲取驗證碼: '獲取驗證碼',
  '{n}秒後重試': '{n}秒後重試',
  記住這台設備7天內無需再次驗證: '記住這台設備，7天內無需再次驗證',
  提交驗證: '提交驗證',
  用戶資訊異常請刷新重試: '用戶資訊異常，請刷新重試',
  驗證碼已發送: '驗證碼已發送',
  驗證失敗請刷新重試: '驗證失敗，請刷新重試',
};
